import SupportGrid from "components/grids/support";
import Bike from "components/svgs/bike";
import Senior from "components/svgs/senior";
import Car from "components/svgs/car";
import Plow from "components/svgs/plow";
import Computer from "components/svgs/computer";
import Feet from "components/svgs/feet";
import Cars from "components/svgs/cars";
import * as React from 'react';
export default {
  SupportGrid,
  Bike,
  Senior,
  Car,
  Plow,
  Computer,
  Feet,
  Cars,
  React
};